import React from "react";

interface DiaryBookingCardCustomerNotesProps {
  notes?: string;
  bookingId?: string;
  showDetailedLabels?: boolean;
}

export const DiaryBookingCardCustomerNotes =
  React.memo<DiaryBookingCardCustomerNotesProps>(
    ({ notes, bookingId, showDetailedLabels }) => {
      if (!showDetailedLabels || !notes) {
        return null;
      }

      const maxLines = 4;
      const lineHeight = 1.4;
      const fontSize = 14;
      const maxHeight = maxLines * lineHeight * fontSize;

      const labelLength = "Customer Requests: ".length;
      const totalContentLength = labelLength + notes.length;
      const charsPerLine = 55;
      const shouldTruncate = totalContentLength > maxLines * charsPerLine;

      return (
        <div className="DiarySidebarListItem__customerNotes">
          <div
            className="DiarySidebarListItem__customerNotes__content"
            style={{
              maxHeight: shouldTruncate ? `${maxHeight}px` : "none",
              overflow: shouldTruncate ? "hidden" : "visible",
              transition: "max-height 0.3s ease-in-out"
            }}
          >
            <strong>Customer Requests:</strong> {notes}
          </div>
          {shouldTruncate && (
            <button
              className="DiarySidebarListItem__customerNotes__expand"
              onClick={() => {
                const contentDiv = document.querySelector(
                  `#Booking_${bookingId} .DiarySidebarListItem__customerNotes__content`
                ) as HTMLElement;
                const expandBtn = document.querySelector(
                  `#Booking_${bookingId} .DiarySidebarListItem__customerNotes__expand`
                ) as HTMLButtonElement;
                if (contentDiv && expandBtn) {
                  const isExpanded = contentDiv.style.maxHeight === "none";
                  contentDiv.style.maxHeight = isExpanded
                    ? `${maxHeight}px`
                    : "none";
                  expandBtn.textContent = isExpanded
                    ? "Show more..."
                    : "Show less";
                }
              }}
              style={{
                background: "none",
                border: "none",
                color: "var(--accent-color, #1fd4d4)",
                cursor: "pointer",
                fontSize: "0.875rem",
                padding: "8px 0 0 0",
                textDecoration: "underline",
                transition: "color 0.2s ease"
              }}
            >
              Show more...
            </button>
          )}
        </div>
      );
    }
  );

DiaryBookingCardCustomerNotes.displayName = "DiaryBookingCardCustomerNotes";
